module.exports = __webpack_public_path__ + "images/psp/truck-storage-options.webp";